import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className="ri-book-open-line text-2xl text-primary-500"></i>
          </div>
          <span className="text-xl font-bold font-heading text-foreground-900 whitespace-nowrap">
            韩漫漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-primary-500 bg-primary-50'
                : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-500 bg-primary-50'
                : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}